import { z } from 'zod';

import { type CreateUserPayload } from '@/modules/api';
import {
  deriveSignedDocuments,
  isLegalKeyAgreed,
  type LegalDocumentGroup,
} from '@/modules/legalDocuments';
import { getServerLocale, getSystemLocale, formatBirthdayForData } from '@/modules/localization';

import { LEGAL_KEY } from '../constants';
import { accountSchema } from '../schema/accountSchema';

type FormValues = z.infer<typeof accountSchema>;

// Derives the customerProfile aggregate booleans + `signedDocuments` from the
// form's `agreements` record against the live legal-document catalog. Both
// halves come from the same source so the legacy booleans and per-doc
// signature records can't drift.
export const buildCreateUserPayload = (
  values: FormValues,
  legalGroups: LegalDocumentGroup[]
): CreateUserPayload => {
  return {
    firstName: values.firstName,
    lastName: values.lastName,
    customerProfile: {
      birthday: formatBirthdayForData(values.birthday),
      smsAllowed: values.sms ?? false,
      termsAndConditionsAccepted: isLegalKeyAgreed(values.agreements, legalGroups, LEGAL_KEY.TERMS),
      informedConsentAccepted: isLegalKeyAgreed(values.agreements, legalGroups, LEGAL_KEY.CONSENT),
      preferredLanguage: getServerLocale(getSystemLocale()),
    },
    email: values.email,
    password: values.password,
    phone: values.phone ?? '',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'UTC',
    signedDocuments: deriveSignedDocuments(values.agreements, legalGroups),
  };
};
